export default __webpack_public_path__ + "static/media/cp_geo_aq.303b11d3.svg";